import React, { forwardRef, useLayoutEffect } from 'react';
import { useAppSelector } from '../../app/hooks';
import TimesheetSections from './TimesheetSections';

const TimesheetTableContainer = forwardRef((props, ref) => {
    const { isLoading } = useAppSelector((state) => state.timesheet);

    if (!isLoading && sessionStorage.getItem('is_saving_active') === 'true') {
        const currentScroll = window.scrollY || document.documentElement.scrollTop;
        if (currentScroll > 0) {
            sessionStorage.setItem('save_scroll_y', currentScroll.toString());
        }
    }

    useLayoutEffect(() => {
        if (!isLoading) {
            const saveScroll = sessionStorage.getItem('save_scroll_y');
            const isSaving = sessionStorage.getItem('is_saving_active') === 'true';

            const deleteScroll = localStorage.getItem('delete_scroll_y');
            const isDeleting = localStorage.getItem('is_deleting_active') === 'true';

            // 1.When Save Action
            if (isSaving && saveScroll) {
                const targetY = Number(saveScroll);
                window.scrollTo(0, targetY);                
                sessionStorage.removeItem('is_saving_active');
                sessionStorage.removeItem('save_scroll_y');
            } 
            // 2. When Delete action
            else if (isDeleting && deleteScroll) {
                const targetY = Number(deleteScroll);
                window.scrollTo(0, targetY);
                
                setTimeout(() => {
                    window.scrollTo(0, targetY);
                }, 150);

                localStorage.removeItem('is_deleting_active');
                localStorage.removeItem('delete_scroll_y');
            }
        }
    }, [isLoading]);

    return (
        <div id="timesheetTable" className={"tableContainer"}>
            {!isLoading && <TimesheetSections ref={ref}/>}
        </div>
    );
});

export default TimesheetTableContainer;


// import React, { forwardRef } from 'react'
// import { useAppSelector } from '../../app/hooks'
// import TimesheetSections from './TimesheetSections'

// const TimesheetTableContainer = forwardRef((props, ref) => {
//     const { isLoading } = useAppSelector((state) => state.timesheet);
//     return (
//         <div id="timesheetTable" className={"tableContainer"}>
//             {!isLoading && <TimesheetSections  ref={ref}/>}
//             {/* <TimesheetSections /> */}
//         </div>
//     )
// }
// )

// export default TimesheetTableContainer